const bhdCartDrawerScript = document.currentScript || document.querySelector('script[src*="cart-drawer.js"]');

function loadBhdCartMobileStyles() {
  if (document.querySelector('link[data-bhd-cart-mobile-v2]')) return;

  const scriptUrl = bhdCartDrawerScript && bhdCartDrawerScript.src;
  if (!scriptUrl) return;

  try {
    const stylesheet = document.createElement('link');
    stylesheet.rel = 'stylesheet';
    const stylesheetUrl = new URL('bhd-cart-mobile-v2.css', scriptUrl);
    stylesheetUrl.searchParams.set('v', '20260904-3');
    stylesheet.href = stylesheetUrl.href;
    stylesheet.setAttribute('data-bhd-cart-mobile-v2', '');
    document.head.appendChild(stylesheet);
  } catch (error) {
    console.error('Barrio mobile cart styles:', error);
  }
}

loadBhdCartMobileStyles();

class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
    primeBhdManualCartRecommendations();
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    Promise.all([
      fetch(this.dataset.url).then((response) => response.text()),
      getBhdManualCartRecommendations(),
    ])
      .then(([html, recommendationMarkup]) => {
        const sectionHtml = this.getSectionInnerHTMLWithRecommendations(
          html,
          '.shopify-section',
          recommendationMarkup
        );

        const miniCart = document.getElementById('mini-cart');
        if (!miniCart) return;

        miniCart.innerHTML = sectionHtml;
        ensureBhdMobileCartStructure(miniCart);
        scheduleBhdCheckoutButtonCleanup();
        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch((error) => {
        console.error(error);
      });
  }

  open() {
    const detailsElement = this.drawer && this.drawer.querySelector('details');
    if (!detailsElement || detailsElement.hasAttribute('open')) {
      syncBhdMobileCartScrollLock();
      scheduleBhdCheckoutButtonCleanup();
      ensureBhdManualRecommendations();
      return;
    }

    this.drawer.openMenuDrawer();
    requestAnimationFrame(syncBhdMobileCartScrollLock);
    scheduleBhdCheckoutButtonCleanup();
    ensureBhdManualRecommendations();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;

    const currentRecommendationMarkup = getBhdCurrentRecommendationMarkup();
    const recommendationMarkup =
      currentRecommendationMarkup || bhdManualCartRecommendationsMarkup || '';

    if (recommendationMarkup) {
      this.renderBhdSections(parsedState, recommendationMarkup);
      this.open();
      return Promise.resolve();
    }

    return getBhdManualCartRecommendations().then((markup) => {
      this.renderBhdSections(parsedState, markup || '');
      this.open();
    });
  }

  renderBhdSections(parsedState, recommendationMarkup) {
    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      const html = parsedState.sections && parsedState.sections[section.id];

      if (!target || !html) return;

      if (section.id === 'mini-cart') {
        target.innerHTML = this.getSectionInnerHTMLWithRecommendations(
          html,
          section.selector,
          recommendationMarkup
        );
        ensureBhdMobileCartStructure(target);
        ensureBhdManualRecommendations(target);
        scheduleBhdCheckoutButtonCleanup();
      } else {
        target.innerHTML = this.getSectionInnerHTML(html, section.selector);
      }
    });
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const element = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);

    return element ? element.innerHTML : '';
  }

  getSectionInnerHTMLWithRecommendations(
    html,
    selector = '.shopify-section',
    recommendationMarkup = ''
  ) {
    const documentFragment = new DOMParser().parseFromString(html, 'text/html');
    const element = documentFragment.querySelector(selector);

    if (!element) return '';

    replaceBhdCartRecommendations(element, recommendationMarkup);
    return element.innerHTML;
  }
}

if (!customElements.get('mini-cart')) {
  customElements.define('mini-cart', MiniCart);
}

let bhdManualCartRecommendationsRequest = null;
let bhdManualCartRecommendationsMarkup = null;
let bhdRecommendationAddBound = false;
let bhdCheckoutButtonCleanupTimer = null;

function getBhdManualCartRecommendations() {
  if (bhdManualCartRecommendationsMarkup) {
    return Promise.resolve(bhdManualCartRecommendationsMarkup);
  }

  if (bhdManualCartRecommendationsRequest) {
    return bhdManualCartRecommendationsRequest;
  }

  const root =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const separator = root.includes('?') ? '&' : '?';
  const url = `${root}${separator}section_id=cart-manual-recommendations&_=${Date.now()}`;

  bhdManualCartRecommendationsRequest = fetch(url, {
    credentials: 'same-origin',
    cache: 'no-store',
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Manual cart recommendations failed: ${response.status}`);
      }
      return response.text();
    })
    .then((html) => {
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const source = documentFragment.querySelector(
        '[data-bhd-manual-cart-recommendations]'
      );

      bhdManualCartRecommendationsMarkup = source ? source.outerHTML : '';
      return bhdManualCartRecommendationsMarkup;
    })
    .catch((error) => {
      console.error('Barrio manual cart recommendations:', error);
      bhdManualCartRecommendationsMarkup = '';
      return '';
    })
    .finally(() => {
      bhdManualCartRecommendationsRequest = null;
    });

  return bhdManualCartRecommendationsRequest;
}

function primeBhdManualCartRecommendations() {
  getBhdManualCartRecommendations();
}

function getBhdCurrentRecommendationMarkup() {
  const current = document.querySelector(
    '#mini-cart [data-bhd-manual-cart-recommendations]'
  );

  if (!current || !current.querySelector('li')) return '';

  const cleanCopy = current.cloneNode(true);
  cleanCopy.querySelectorAll('[data-bhd-rec-add]').forEach((button) => {
    button.removeAttribute('disabled');
    button.removeAttribute('aria-busy');
    button.classList.remove('loading');
    button.dataset.loading = 'false';
  });

  return cleanCopy.outerHTML;
}

function replaceBhdCartRecommendations(container, recommendationMarkup) {
  const recommendationBlocks = [
    ...container.querySelectorAll('.cart-recommendations'),
  ];

  if (!recommendationMarkup) {
    recommendationBlocks.forEach((block) => block.remove());
    return;
  }

  const holder = document.createElement('div');
  holder.innerHTML = recommendationMarkup;
  const source = holder.firstElementChild;

  if (!source) {
    recommendationBlocks.forEach((block) => block.remove());
    return;
  }

  if (!recommendationBlocks.length) {
    const miniCart = container.matches && container.matches('.mini-cart')
      ? container
      : container.querySelector('.mini-cart');

    if (miniCart && !miniCart.classList.contains('is-empty')) {
      const main = miniCart.querySelector('.mini-cart__main');
      if (main) main.appendChild(source.cloneNode(true));
    }
    return;
  }

  recommendationBlocks.forEach((block) => {
    const replacement = source.cloneNode(true);

    if (block.hasAttribute('data-animate')) {
      replacement.setAttribute('data-animate', '');
    }

    [...block.attributes].forEach((attribute) => {
      if (attribute.name.startsWith('data-animate-delay-')) {
        replacement.setAttribute(attribute.name, attribute.value);
      }
    });

    block.replaceWith(replacement);
  });
}

async function ensureBhdManualRecommendations(root = document.getElementById('mini-cart')) {
  if (!root) return;

  const miniCart = root.matches && root.matches('.mini-cart')
    ? root
    : root.querySelector('.mini-cart');

  if (!miniCart || miniCart.classList.contains('is-empty')) return;

  const populated = miniCart.querySelector(
    '[data-bhd-manual-cart-recommendations] li'
  );
  if (populated) return;

  const markup = await getBhdManualCartRecommendations();
  if (!markup) return;

  replaceBhdCartRecommendations(root, markup);
}

function cleanBhdCheckoutButtonSeparator(root = document) {
  const button = root.querySelector && root.querySelector(
    '.cart-drawer .button-container button[name="checkout"], .button-container button[name="checkout"]'
  );
  if (!button) return;

  const cleanLabel = (value) =>
    String(value || '')
      .replace(/\s+/g, ' ')
      .replace(/(?:\s*[—–-]+\s*)+$/, '')
      .trim();

  const label = button.querySelector('.bhd-checkout-price-button__label');
  if (label) {
    const normalized = cleanLabel(label.textContent);
    if (normalized) label.textContent = normalized;
  }

  if (button.dataset.bhdCheckoutLabel) {
    const normalizedCachedLabel = cleanLabel(button.dataset.bhdCheckoutLabel);
    if (normalizedCachedLabel) {
      button.dataset.bhdCheckoutLabel = normalizedCachedLabel;
    }
  }

  const separators = [
    ...button.querySelectorAll('.bhd-checkout-price-button__separator'),
  ];

  separators.forEach((separator, index) => {
    if (index === 0) {
      separator.textContent = '—';
    } else {
      separator.remove();
    }
  });
}

function scheduleBhdCheckoutButtonCleanup() {
  clearTimeout(bhdCheckoutButtonCleanupTimer);
  bhdCheckoutButtonCleanupTimer = setTimeout(() => {
    cleanBhdCheckoutButtonSeparator();
  }, 120);
}

function resetBhdRecommendationButtons(variantId, originalButton) {
  const matchingButtons = [
    ...document.querySelectorAll('[data-bhd-rec-add]'),
  ].filter(
    (button) => String(button.dataset.variantId) === String(variantId)
  );

  [originalButton, ...matchingButtons].filter(Boolean).forEach((button) => {
    button.dataset.loading = 'false';
    button.disabled = false;
    button.removeAttribute('aria-busy');
    button.classList.remove('loading');
  });
}

function bindBhdRecommendationAdd() {
  if (bhdRecommendationAddBound) return;
  bhdRecommendationAddBound = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest && event.target.closest('[data-bhd-rec-add]');
    if (!button) return;

    event.preventDefault();

    const variantId = button.dataset.variantId;
    if (!variantId || button.dataset.loading === 'true') return;

    button.dataset.loading = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.classList.add('loading');

    try {
      const miniCart = document.querySelector('mini-cart');
      const sections = miniCart
        ? miniCart.getSectionsToRender().map((section) => section.id)
        : ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];

      const body = JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: sections,
        sections_url: window.location.pathname,
      });

      const response = await fetch(`${theme.routes.cart_add_url}`, {
        ...fetchConfig('javascript'),
        body,
      });
      const parsedState = await response.json();

      if (!response.ok || parsedState.status) {
        const errorMessage =
          parsedState.description || parsedState.message || 'Unable to add this item.';

        document.dispatchEvent(
          new CustomEvent('ajaxProduct:error', {
            detail: { errorMessage },
          })
        );
        return;
      }

      const liveMiniCart = document.querySelector('mini-cart');
      if (liveMiniCart) {
        await liveMiniCart.renderContents(parsedState);
      }

      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          detail: { product: parsedState },
        })
      );
    } catch (error) {
      console.error('Barrio recommendation add:', error);
    } finally {
      resetBhdRecommendationButtons(variantId, button);
    }
  });
}

function ensureBhdMobileCartStructure(root = document.getElementById('mini-cart')) {
  if (!root || !window.matchMedia('(max-width: 749px)').matches) return;

  const cart = root.matches && root.matches('.mini-cart')
    ? root
    : root.querySelector('.mini-cart');

  if (!cart || cart.classList.contains('is-empty')) return;

  const inner = cart.querySelector('.mini-cart__inner');
  if (!inner || inner.querySelector(':scope > .bhd-mini-cart-scroll')) return;

  const header = [...inner.children].find((child) =>
    child.classList.contains('mini-cart__header')
  );
  const main = [...inner.children].find((child) =>
    child.classList.contains('mini-cart__main')
  );

  if (!header || !main) return;

  const scrollRegion = document.createElement('div');
  scrollRegion.className = 'bhd-mini-cart-scroll';
  inner.insertBefore(scrollRegion, header);
  scrollRegion.append(header, main);
}

let bhdCartPageLocked = false;
let bhdCartObserverStarted = false;

function isBhdMobileCartOpen() {
  if (!window.matchMedia('(max-width: 749px)').matches) return false;

  return Boolean(
    document.querySelector('.cart-drawer-container details[open] > .cart-drawer') ||
      document.documentElement.classList.contains('mini-cart--open') ||
      document.body.classList.contains('mini-cart--open')
  );
}

function syncBhdMobileCartScrollLock() {
  const shouldLock = isBhdMobileCartOpen();

  document.documentElement.classList.toggle(
    'bhd-cart-page-locked',
    shouldLock
  );
  document.body.classList.toggle('bhd-cart-page-locked', shouldLock);
  bhdCartPageLocked = shouldLock;

  if (shouldLock) {
    ensureBhdMobileCartStructure();
  }
}

function preventBhdBackgroundTouchScroll(event) {
  if (!bhdCartPageLocked) return;

  const target = event.target;
  if (!(target instanceof Element)) {
    event.preventDefault();
    return;
  }

  if (
    target.closest('.bhd-mini-cart-scroll') ||
    target.closest('.mini-cart__action[open] > summary + *')
  ) {
    return;
  }

  event.preventDefault();
}

function startBhdCartObservers() {
  if (bhdCartObserverStarted) return;
  bhdCartObserverStarted = true;

  const rootObserver = new MutationObserver(syncBhdMobileCartScrollLock);
  rootObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
  });

  const drawerObserver = new MutationObserver(() => {
    ensureBhdMobileCartStructure();
    syncBhdMobileCartScrollLock();
  });
  drawerObserver.observe(document.body, {
    subtree: true,
    attributes: true,
    attributeFilter: ['open'],
  });

  window.addEventListener(
    'resize',
    () => {
      ensureBhdMobileCartStructure();
      syncBhdMobileCartScrollLock();
      scheduleBhdCheckoutButtonCleanup();
    },
    { passive: true }
  );

  document.addEventListener('toggle', syncBhdMobileCartScrollLock, true);
  document.addEventListener(
    'touchmove',
    preventBhdBackgroundTouchScroll,
    { passive: false }
  );

  document.addEventListener('cartdrawer:opened', () => {
    ensureBhdMobileCartStructure();
    ensureBhdManualRecommendations();
    syncBhdMobileCartScrollLock();
    scheduleBhdCheckoutButtonCleanup();
  });

  document.addEventListener('cart:updated', () => {
    ensureBhdMobileCartStructure();
    ensureBhdManualRecommendations();
    scheduleBhdCheckoutButtonCleanup();
  });

  syncBhdMobileCartScrollLock();
}

function initializeBhdCartEnhancements() {
  primeBhdManualCartRecommendations();
  bindBhdRecommendationAdd();
  ensureBhdMobileCartStructure();
  ensureBhdManualRecommendations();
  scheduleBhdCheckoutButtonCleanup();
  startBhdCartObservers();
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initializeBhdCartEnhancements,
    { once: true }
  );
} else {
  initializeBhdCartEnhancements();
}
